'use client';

import { forwardRef } from 'react';

import { Icon } from '../icon/icon';
import { IconSpinner } from './icon-spinner';
import { spinnerStyles } from './styles/spinner.styles';
import type { SpinnerPropsInterface } from './types/spinner.types';

export const Spinner = forwardRef<SVGSVGElement, SpinnerPropsInterface>(
  (props: SpinnerPropsInterface, forwardedRef) => {
    const {
      size,
      css: cssProp,
      title = 'Loading',
      onImpact = false,
      fixedMode = false,
      ...rest
    } = props;

    return (
      <Icon
        data-c11n-component="Spinner"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        size={size}
        title={title || undefined}
        css={{ ...spinnerStyles.raw({ onImpact, fixedMode }), ...cssProp }}
        {...rest}
      >
        <IconSpinner />
      </Icon>
    );
  },
);

Spinner.displayName = 'Spinner';
